import React from 'react';

import SubForm, { mapSubToValues } from '../../components/SubForm';
import SubNav from '../../components/SubNav';
import { sortByEffectiveDate } from '../../helpers/subs';
import getCarrier from '../../helpers/getCarrier';
import { capitalize } from '../../helpers/strings';

let EditSub = ({
  sub,
  subId,
  userId,
  updateSub,
  saveStatus,
  isAdmin,
  initialSubs,
  fetchAllInitialsSubs,
  initialSubsLoading,
  carrierPrefix,
  isSimo,
  coverageOptions,
}) => {
  const hideEditCoverage =
    isSimo && !['new', 'acknowledged', 'error'].includes(sub?.simo_status);

  const handleChangeActivationType = (e) => {
    const value = e.target.value;
    const allCarriers = ['att', 'sprint', 'tracfone', 'simo'];

    if (value === 'internal_movement' || value === 'mdn_change') {
      fetchAllInitialsSubs(
        {
          user_profile: userId,
        },
        {
          sort: sortByEffectiveDate,
          expiry_type: value,
          carriers:
            value === 'mdn_change'
              ? allCarriers.filter((carrier) => carrier === carrierPrefix)
              : allCarriers.filter((carrier) => carrier !== carrierPrefix),
        },
      );
    }
  };

  const getInitialSub = (initialSubscription) => {
    if (!initialSubscription) {
      return {};
    }

    const sub = initialSubs.find(
      (sub) => sub.id === parseInt(initialSubscription, 10),
    );
    const carrier = getCarrier(sub);

    return {
      [`initial_${carrier}_subscription`]: initialSubscription,
    };
  };

  const handleSubmit = ({
    initial_subscription,
    initial_subscription_manual,
    initial_subscription_manual_carrier,
    use_manual_initial_sub,
    ...values
  }) => {
    if (use_manual_initial_sub) {
      return updateSub(subId, {
        ...values,
        user_profile: userId,
        [`initial_${initial_subscription_manual_carrier}_subscription`]:
          initial_subscription_manual,
      });
    }

    return updateSub(subId, {
      ...values,
      user_profile: userId,
      ...getInitialSub(initial_subscription),
    });
  };

  if (!sub) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <h1>
        Edit {capitalize(carrierPrefix)} Subscription (ID: {subId})
      </h1>
      <SubNav />
      <SubForm
        initialValues={mapSubToValues(sub)}
        onSubmit={handleSubmit}
        saveStatus={saveStatus}
        isAdmin={isAdmin}
        handleChangeActivationType={handleChangeActivationType}
        initialSubs={initialSubs}
        initialSubsLoading={initialSubsLoading}
        isSimo={isSimo}
        coverageOptions={coverageOptions}
        hideEditCoverage={hideEditCoverage}
      />
    </div>
  );
};

export default EditSub;
